<template>
  <swiper-container
    class="mySwiper"
    navigation="true"
    pagination="true"
    loop="true"
    autoplay-delay="5000"
    autoplay-disable-on-interaction="false"
    speed="1000"
    slides-per-view="1"
    space-between="0"
    v-if="banners.length > 0"
  >
    <swiper-slide v-for="banner in banners" :key="banner.sequencia">
      <a
        v-if="banner.link"
        :href="banner.link"
        target="_blank"
        class="banner-link"
      >
        <img
          :src="`https://${banner.banner}`"
          :alt="banner.title"
          class="banner-image"
        />
      </a>
      <img
        v-else
        :src="`https://${banner.banner}`"
        :alt="banner.title"
        class="banner-image"
      />
    </swiper-slide>
  </swiper-container>

  <div class="d-flex container justify-content-space-between">
    <h1>Todos os produtos</h1>
    <div id="margin" class="row">
      <p id="ordem" class="col">Ordenar por:</p>
      <select
        @change="onChange($event)"
        class="form-select d-inline col"
        id="orderby"
        style="width: fit-content"
        aria-label="select"
        v-model="ordenacao"
      >
        <option value="LAN%C3%87AMENTO" selected>LANÇAMENTO</option>
        <option value="MENOR%20PRE%C3%87O">MENOR PREÇO</option>
        <option value="MAIOR%20PRE%C3%87O">MAIOR PREÇO</option>
        <option value="MAIS%20VENDIDOS">MAIS VENDIDOS</option>
        <option value="MAIOR%20ESTOQUE">MAIOR ESTOQUE</option>
        <option value="MENOR%20ESTOQUE">MENOR ESTOQUE</option>
      </select>
    </div>
  </div>
  <hr />
  <img
    v-if="topovisibility"
    @click="top"
    id="back-to-top"
    src="../../public/totop.png"
    alt="voltar ao topo botão"
    :style="{ bottom: empresarodape.whatsappcontato ? '90px' : '20px' }"
  />
  <a
    v-if="empresarodape.whatsappcontato"
    :href="`https://wa.me/${empresarodape.whatsappcontato}`"
    target="_blank"
    class="whatsapp-icon"
  >
    <img src="../../public/whatsapp.png" alt="WhatsApp" />
  </a>
  <div>
    <div class="container">
      <ul style="padding: 0; min-height: 100vh">
        <div v-if="isCargando">
          <base-spinner></base-spinner>
        </div>
        <div class="row" v-if="!isCargando">
          <item-produto
            class="col-md col-6 p-1"
            v-for="produto in produtos"
            :key="produto.codigo"
            :nomeproduto="produto.nomeproduto"
            :url="produto.url"
            :detalhes="produto.detalhes"
            :preco="produto.preco"
            :saldo="produto.saldo"
            :codigo="produto.codigo"
            :referencia="produto.referencia"
          >
          </item-produto>
          <div
            class="text-center"
            style="margin-top: 50px"
            v-if="!isCargando && !isLoading && !acabouProdutos"
          >
            <button class="btn btn-primary my-3" @click="verMaisProdutos">
              Ver mais produtos
            </button>
          </div>
        </div>
        <p v-if="acabouProdutos" class="text-center text-muted my-3">
          Não há mais produtos para carregar.
        </p>
        <div v-if="isLoading" style="margin-top: 50px">
          <base-spinner></base-spinner>
        </div>
      </ul>
    </div>
  </div>
  <AppFooter id="footer" />
</template>

<script>
import ItemProduto from "../components/produtos/ItemProduto.vue";
import { mapState } from "vuex";
import AppFooter from "@/components/AppFooter.vue";

export default {
  components: {
    ItemProduto,
    AppFooter,
  },
  props: {
    tokenTipo: String,
    tokenLoja: String,
  },
  data() {
    return {
      search: "",
      ordenacao: "LAN%C3%87AMENTO",
      isLoading: false,
      isCargando: false,
      topovisibility: false,
    };
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("empresa", ["banners"]),
    ...mapState("produtos", ["produtos"]),
    ...mapState("produtos", ["categoria"]),
    ...mapState("empresa", ["permissaoUsuario"]),
    ...mapState("login", ["dadosCliente"]),
    ...mapState("login", ["usuarioLogado"]),

    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    permissaoUsuarioPage() {
      if (this.permissaoUsuario == "2") {
        return true;
      } else if (this.permissaoUsuario == "1" && this.usuarioLogado == true) {
        if (this.dadosCliente.aprovado == "S") {
          return true;
        }
        return false;
      } else return false;
    },
    acabouProdutos() {
      return this.$store.getters["produtos/acabouprodutos"] === "acabou";
    },
  },
  methods: {
    async carregarProdutos() {
      if (this.produtos.length === 0 || this.produtos.length === 4) {
        this.isLoading = true;
        await this.$store.dispatch("produtos/carregarProdutos", {
          ordem: this.ordenacao,
        });
        this.isLoading = false;
      }
    },
    async onChange(event) {
      this.ordenacao = event.target.value;
      this.isCargando = true;

      await this.$store.dispatch("loja/resetPaginacao");
      await this.$store.dispatch("produtos/resetProdutos");
      await this.$store.dispatch("produtos/carregarProdutos", {
        ordem: this.ordenacao,
      });

      this.$nextTick(() => {
        this.isCargando = false;
      });
    },
    async carregarRodape() {
      await this.$store.dispatch("empresa/carregarRodape");
      document.title = this.empresarodape.nome;
    },
    async carregarBanners() {
      await this.$store.dispatch("empresa/carregarBanners");
    },
    async carregarCategorias() {
      await this.$store.dispatch("produtos/carregarCategorias");
    },
    async resertCarousel() {
      await this.$store.dispatch("produtos/resertCarousel");
    },
    async verMaisProdutos() {
      if (this.isLoading || this.acabouProdutos) return;

      this.isLoading = true;

      await this.$store.dispatch("loja/paginacao");
      await this.$store.dispatch("produtos/carregarProdutos", {
        ordem: this.ordenacao,
      });
      this.isLoading = false;
    },
    top() {
      window.scrollTo(0, 0);
    },
    carregarPermissaoUsuario() {
      this.$store.dispatch("empresa/permissaoUsuario");
    },
  },
  created() {
    this.carregarRodape();
    this.carregarBanners();
    this.carregarCategorias();
    this.resertCarousel();
    this.carregarPermissaoUsuario();
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.topovisibility = window.scrollY >= 1145;
    });

    if (this.tokenLoja === "tayle") {
      this.ordenacao = "MAIOR%20ESTOQUE";
    }
    this.carregarProdutos();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");
@import "@/styles/variables.css";

#orderby:focus {
  border-color: var(--primary-color);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #13433a;
}

#back-to-top {
  position: fixed;
  width: 60px;
  right: 0%;
  cursor: pointer;
}

.whatsapp-icon {
  position: fixed;
  width: 60px;
  bottom: 20px;
  right: 0%;
  cursor: pointer;
  z-index: 1000;
}

.whatsapp-icon img {
  width: 100%;
  height: auto;
  margin: 0;
}

.fullbody {
  min-height: 100vh;
}

ul {
  list-style: none;
  margin: 2rem auto;
}

div {
  margin: 0;
  padding: 0;
  margin: auto;
  max-width: 85rem;
}

img {
  margin-left: 1rem;
}

input {
  margin: 0;
  margin: auto;
  width: 90%;
}

h1 {
  color: var(--primary-color);
  margin: 40px;
}

swiper-container {
  width: 100%;
  margin-bottom: 2rem;
}

swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.banner-link {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-image {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  margin: 0;
  transition: transform 0.3s ease;
}

.banner-link:hover .banner-image {
  transform: scale(1.05);
}

/* Customização dos controles do Swiper */
swiper-container::part(button-prev),
swiper-container::part(button-next) {
  color: var(--primary-color);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin-top: -20px;
  transition: all 0.3s ease;
}

swiper-container::part(button-prev):hover,
swiper-container::part(button-next):hover {
  background-color: var(--primary-color);
  color: white;
  transform: scale(1.1);
}

swiper-container::part(pagination) {
  bottom: 20px;
}

swiper-container::part(bullet) {
  background-color: rgba(255, 255, 255, 0.5);
  opacity: 1;
  border: 2px solid white;
  width: 12px;
  height: 12px;
}

swiper-container::part(bullet-active) {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  transform: scale(1.2);
}

button:hover,
button:active {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

button {
  font: inherit;
  cursor: pointer;
  background-color: var(--primary-color);
  color: white;
  border: 1px solid var(--primary-color);
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
}
</style>
